import React, { lazy } from 'react'

// Named exports
const TotalProductCapabilities = lazy(() =>
  import('../../../../globalComponents/Rfi1').then((m) => ({
    default: m.TotalProductCapabilities,
  })),
)
const LeadTime = lazy(() =>
  import('../../../../globalComponents/Rfi1').then((m) => ({
    default: m.LeadTime,
  })),
)
const DesignCompetency = lazy(() =>
  import('../../../../globalComponents/Rfi1').then((m) => ({
    default: m.DesignCompetency,
  })),
)
const BeautyFormulationCapabilities = lazy(() =>
  import('../../../../globalComponents/RfiCommons').then((m) => ({
    default: m.BeautyFormulationCapabilities,
  })),
)
const BeautyPackagingCapabilities = lazy(() =>
  import('../../../../globalComponents/RfiCommons').then((m) => ({
    default: m.BeautyPackagingCapabilities,
  })),
)
const Certifications = lazy(() =>
  import('../../../../globalComponents/RfiCommons').then((m) => ({
    default: m.Certifications,
  })),
)
const MaterialCapabilities = lazy(() =>
  import('../../../../globalComponents/Rfi2').then((m) => ({
    default: m.MaterialCapabilities,
  })),
)
const FactoryCapabilities = lazy(() =>
  import('../../../../globalComponents/Rfi2').then((m) => ({
    default: m.FactoryCapabilities,
  })),
)
const EmployeeInformation = lazy(() =>
  import('../../../../globalComponents/Rfi2').then((m) => ({
    default: m.EmployeeInformation,
  })),
)

const FoorwearEmployeeInformation = lazy(() =>
  import('../../../../globalComponents/Rfi2').then((m) => ({
    default: m.FootwearEmployeeInformation,
  })),
)
const DynamicSectionBuilder = lazy(() =>
  import('../../../../globalComponents/Builders').then((m) => ({
    default: m.DynamicSectionBuilder,
  })),
)

// Default exports
const RawMaterialProductCapabilities = lazy(
  () =>
    import('../../../../globalComponents/Rfi1/RawMaterialCapabilities/ProductCapabilitySection'),
)
const PackagingEquipment = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/packaging/PackagingEquipment'),
)
const RawMaterialMachinary = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/rawmaterial/RawMaterialMachinary'),
)

// NEW: secondary processing + laundry sections
const SecondaryProcessingCapabilities = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/secondaryprocessing/SecondaryProcessingCapabilities'),
)
const LaundryDependentListSection = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/secondaryprocessing/LaundryDependentListSection'),
)
const LaundryProductTypes = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/secondaryprocessing/LaundryProductTypes'),
)
const RawMaterialManufacturingProcess = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/rawmaterial/RawMaterialManufacturingProcess'),
)

const TextileToTextileRecyclingCapabilities = lazy(
  () =>
    import('../../../../globalComponents/Rfi2/rawmaterial/TextileToTextile'),
)

export function getSectionComponent(sectionUid, { isReadonly }) {
  const uid = String(sectionUid || '').toUpperCase()

  switch (uid) {
    case 'RAW_MATERIAL_CAPABILITIES':
      return RawMaterialProductCapabilities
    case 'SECONDARY_PROCESSING_CAPABILITIES':
      return SecondaryProcessingCapabilities
    case 'TOTAL_PRODUCT_CAPABILITIES':
      return TotalProductCapabilities
    case 'BEAUTY_FORMULATION_CAPABILITIES':
      return BeautyFormulationCapabilities
    case 'BEAUTY_PACKAGING_CAPABILITIES':
      return BeautyPackagingCapabilities
    case 'FACTORY_CAPABILITIES':
      return FactoryCapabilities
    case 'EMPLOYEE_INFORMATION':
      return EmployeeInformation
    case 'FOOTWEAR_EMPLOYEE_INFORMATION':
      return FoorwearEmployeeInformation
    case 'MATERIAL_CAPABILITY':
      return isReadonly ? DynamicSectionBuilder : MaterialCapabilities
    case 'PACKAGING_EQUIPMENT':
      return PackagingEquipment
    case 'RAW_MATERIAL_MANUFACTURING_PROCESS':
      return RawMaterialManufacturingProcess
    case 'RAW_MATERIAL_MACHINERY':
      return RawMaterialMachinary
    case 'LAUNDRY_EQUIPMENT_AND_FACILITIES':
    case 'LAUNDRY_UTILITIES_AND_INFRASTRUCTURE':
      return LaundryDependentListSection
    case 'LAUNDRY_PRODUCT_TYPES':
      return LaundryProductTypes
    case 'TEXTILE_TO_TEXTILE_RECYCLING_CAPABILITIES':
      return TextileToTextileRecyclingCapabilities
    case 'CERTIFICATIONS':
    case 'FACTORY_REGISTRATION_LICENSE':
      return isReadonly ? DynamicSectionBuilder : Certifications
    case 'LEAD_TIME':
      return isReadonly ? DynamicSectionBuilder : LeadTime
    case 'DESIGN_COMPETENCY':
      return DesignCompetency
    default:
      return DynamicSectionBuilder
  }
}
